import { merge, Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import background from '../../../assets/background.png';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import Form from './Form';
import Pictogrammes from './Pictogrammes';
import Title from './Title';

const Content = () => {

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                inner: { root: { width: "100%" } },
                outer: { root: { width: "100%" } },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        inner: {
                            root: {
                                filter: "drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.5))",
                                width: "auto"
                            }
                        },
                        outer: {
                            root: {
                                backgroundImage: `url(${background})`,
                                backgroundPosition: "right top -365px",
                                backgroundSize: 1500,
                                boxShadow: "inset 0px 200px 250px rgba(0, 0, 0, 0.4)",
                                justifyContent: "center",
                                paddingBottom: 20,
                                paddingTop: 20,
                                selectors: { "@media(min-width:1500px)": { backgroundSize: "cover" } }
                            }
                        }
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Stack
        as="main"
        grow
        horizontalAlign="center"
        styles={styles.outer}
        tokens={{ childrenGap: "2vh" }}
    >
        {responsiveSize >= ResponsiveSize.medium && <Title />}
        <Stack horizontal={responsiveSize >= ResponsiveSize.medium} styles={styles.inner}>
            <Form />
            <Pictogrammes />
        </Stack>
    </Stack>;

};

export default Content;